import createIcon from '../../createIcon';

/**
 * @component @name RMobiledata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuMyAxMy4yTDE1LjUgMTZIMTMuNUwxMi4zNyAxMy4zM0gxMC41VjE2SDguNVY4SDEzLjVDMTQuNjMgOCAxNS41IDguODcgMTUuNSAxMFYxMS4zM0MxNS41IDEyLjEzIDE0Ljk3IDEyLjg3IDE0LjMgMTMuMlpNMTMuNSAxMEgxMC41VjExLjMzSDEzLjVWMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RMobiledata = createIcon('RMobiledata', [
  [
    'path',
    {
      d: 'M14.3 13.2L15.5 16H13.5L12.37 13.33H10.5V16H8.5V8H13.5C14.63 8 15.5 8.87 15.5 10V11.33C15.5 12.13 14.97 12.87 14.3 13.2ZM13.5 10H10.5V11.33H13.5V10Z',
      key: '7ddvuy',
    },
  ],
]);

export default RMobiledata;
